import React, { ReactElement } from 'react';
import { CSSProp } from 'styled-components';

import { Info as InfoIcon } from 'src/svg/info';
import { Warning as WarningIcon } from 'src/svg/warning';
import { ErrorExclamation as ErrorIcon } from 'src/svg/error-exclamation';
import { ErrorExclamationV2 as ErrorIconV2 } from 'src/svg/error-exclamation-v2';

import { Container, Content, IconContainer } from './inline-banner.styles';

export type InlineBannerProps = {
  border?: boolean;
  children?: ReactElement | string;
  description?: string;
  padding?: string;
  severity?: 'error' | 'errorV2' | 'info' | 'warning';
  title?: string;
  contentStyles?: CSSProp;
  noBorder?: boolean;
};

export function InlineBanner({
  children,
  title,
  description,
  severity = 'info',
  padding = `16px`,
  border = true,
  contentStyles,
  noBorder = false,
}: InlineBannerProps): JSX.Element | null {
  const Icon = (): JSX.Element => {
    switch (severity) {
      default:
      case 'info':
        return <InfoIcon />;
      case 'error':
        return <ErrorIcon />;
      case 'errorV2':
        return <ErrorIconV2 />;
      case 'warning':
        return <WarningIcon />;
    }
  };

  return (
    <Container severity={severity} padding={padding} border={border} noBorder={noBorder}>
      <IconContainer>
        <Icon />
      </IconContainer>
      <Content customStyles={contentStyles}>
        {title && <strong>{title}</strong>}
        {description && <p>{description}</p>}
        {children}
      </Content>
    </Container>
  );
}
